import { createPortal } from 'react-dom';
import './ModalOverlay.css';

/**
 * Full-screen modal scrim, rendered into <body> via portal.
 * Portaling keeps it out of any ancestor stacking context, overflow clip
 * or transform — which otherwise break `position: fixed`.
 *
 * Props:
 *   onClose   fn     — optional; called when the scrim itself is clicked
 *   className string — optional modifier (e.g. `modal-overlay--sheet`)
 *   children
 */
export default function ModalOverlay({ onClose, className = '', children }) {
  const handleClick = onClose
    ? (e) => { if (e.target === e.currentTarget) onClose(); }
    : undefined;

  return createPortal(
    <div className={`modal-overlay ${className}`.trim()} onClick={handleClick}>
      {children}
    </div>,
    document.body
  );
}
